import { render, staticRenderFns } from "./wMedicine2.0.vue?vue&type=template&id=0d6fe46b&scoped=true&"
import script from "./wMedicine2.0.vue?vue&type=script&lang=js&"
export * from "./wMedicine2.0.vue?vue&type=script&lang=js&"
import style0 from "./wMedicine2.0.vue?vue&type=style&index=0&id=0d6fe46b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6fe46b",
  null
  
)

export default component.exports